import React from 'react';
import { DatePicker, Alert, LocaleProvider } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import enUS from 'antd/lib/locale-provider/en_US';
import s from './styles.less';

const renderField = ({
  input,
  label,
  type,
  meta: { touched, error },
  placeholder,
  disabled,
  disabledDate,
}) => (
  <div {...label && { className: s.flex }}>
    {label && <div>{label}</div>}
    <div>
      <LocaleProvider locale={enUS}>
        <DatePicker
          {...input.value && {
            value: moment(input.value),
          }}
          className={s.full}
          format="Do MMMM YYYY"
          onChange={val => input.onChange(val)}
          id={input.name}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          disabledDate={disabledDate}
        />
      </LocaleProvider>
      {touched && error && <Alert message={error} type="error" />}
    </div>
  </div>
);
renderField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  disabledDate: PropTypes.any,
};

export default renderField;
